__turbopack_context__.v({
  "className": "geist_mono_27b0e833-module__gttSBq__className",
  "variable": "geist_mono_27b0e833-module__gttSBq__variable",
});
